import { AxiosResponse } from 'axios'
import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects'

import {
  Configuration,
  ConfigurationGeneratorYield,
  FAIL_FETCH_CONFIGURATION,
  IFetchConfiguration,
  FETCH_CONFIGURATION,
  SUCCESS_FETCH_CONFIGURATION,
} from '.'
import getConfiguration from '../../services/getConfiguration'

function* fetchConfiguration({
  payload: { slug },
}: IFetchConfiguration): Generator<ConfigurationGeneratorYield, void, AxiosResponse<Configuration>> {
  try {
    const { data } = yield call(getConfiguration, slug)

    yield put({
      type: SUCCESS_FETCH_CONFIGURATION,
      payload: data,
    })
  } catch (err) {
    console.error(err)
    yield put({
      type: FAIL_FETCH_CONFIGURATION,
      payload: JSON.stringify(err),
    })
  }
}

export function* configurationSaga(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(FETCH_CONFIGURATION, fetchConfiguration)
}
